export const isValidEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const EMAIL_VALIDATION_ERROR_MESSAGE = "Please enter a valid email address";
